import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService{
  private headers;

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/adminDashboard/';

  getPendingRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyPendingCount/')
  }

  getRejectRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyRejectCount/')
  }

  getIssuedRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyIssuedCount/')
  }

  getTotalRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyTotalCount/')
  }

  getDataEntryRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyDataEntryCount/')
  }

  getBiometricRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyBiometricCount/')
  }

  getSHORequestCount(){
    return this.http.get(this.baseUrl + 'getDailySHOCount/')
  }

  getExaminerRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyExaminerCount/')
  }

  getDGRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyDGCount/')
  }

  getPrintingRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyPrintingCount/')
  }

  getQARequestCount(){
    return this.http.get(this.baseUrl + 'getDailyQACount/')
  }

  getScanRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyScanCount/')
  }

  getDispatchRequestCount(){
    return this.http.get(this.baseUrl + 'getDailyDispatchCount/')
  }

  getMonthWiseSubmittedCount(){
    return this.http.get(this.baseUrl + 'getMonthWiseSubmittedCount/')
  }

  getWeekWiseRequestCount(){
    return this.http.get(this.baseUrl+'getWeekWiseRequestCount/')
  }


  getMonthWisePendingCount() {
    return this.http.get(this.baseUrl+'getMonthWisePendingCount/')
  }


  getMonthWiseRejectedCount() {
    return this.http.get(this.baseUrl+'getMonthWiseRejectedCount/')
  }

  getMonthWiseIssuedCount() {
    return this.http.get(this.baseUrl+'getMonthWiseIssuedCount/')
  }
}
